import { Auth, Amplify } from "aws-amplify";
import "App.css";
import "responsive.css";
import Routes from "Routers/Routes";

import config from "./aws-exports";
import Maintenance from "UnderMaintenance";

const updatedAwsConfig = {
  ...config,
  // Set API to use id token. This will ensure email is passed within the token
  API: {
    graphql_headers: async () => ({
      Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
    }),
  },
};

// Allow overriding the blustreamREST API endpoint via environment variable.
// This lets developers point at a local Gandalf instance (or any other
// environment) without editing aws-exports.js or the gandalfproxy Lambda.
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
if (apiBaseUrl) {
  updatedAwsConfig.aws_cloud_logic_custom = (config.aws_cloud_logic_custom || []).map(
    (api) => api.name === "blustreamREST" ? { ...api, endpoint: apiBaseUrl } : api
  );
}

const REGEX = /.*-(\w+)/;
const env = config.aws_content_delivery_bucket.match(REGEX)[1];
if (env === "prod") {
  updatedAwsConfig["aws_user_files_s3_bucket"] =
    "live-s3-gandalf-contactcsvuploads";
}
Amplify.configure(updatedAwsConfig);

function App() {
  return (
    <>
      {process.env.REACT_APP_IS_UNDER_MAINTENANCE === "true" ? (
        <Maintenance />
      ) : (
        <Routes />
      )}
    </>
  );
}

export default App;
